import { z } from 'zod'
import { useMemo } from 'react'
import { useQueryStates } from 'nuqs'
import { parseAsZodSchema, parseAsSearchQuery } from '@util'
import { isDefined } from '@terros/common'
import { UniversalSearchGroupSchema } from '@front/model'

const WebSearchScopeSchema = z.enum([...UniversalSearchGroupSchema.options, 'destinations'])
export type WebSearchScope = z.infer<typeof WebSearchScopeSchema>

type UniversalSearchOptions = {
  scope?: WebSearchScope | null
  query?: string
}

type UseUniversalSearchType = [UniversalSearchOptions, (arg0: UniversalSearchOptions) => void]

export const useUniversalSearch = (): UseUniversalSearchType => {
  const universalSearchParams = useMemo(
    () => ({
      universalQuery: parseAsSearchQuery,
      search: parseAsZodSchema(WebSearchScopeSchema),
    }),
    []
  )
  const [{ universalQuery, search }, setQueryState] = useQueryStates(universalSearchParams)
  const setter = ({ scope = 'all', query }: UniversalSearchOptions): void => {
    setQueryState({
      search: scope,
      ...(isDefined(query) ? { universalQuery: query } : {}),
    })
  }
  return [{ scope: search, query: universalQuery ?? '' }, setter]
}

export const useOpenUniversalSearch = (onOpen?: VoidFunction): VoidFunction => {
  const [, setUniversalSearch] = useUniversalSearch()

  return (): void => {
    setUniversalSearch({ scope: 'all' })
    onOpen?.()
  }
}
